import { BankOutlined, DollarOutlined, EditOutlined, GlobalOutlined, MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Card, Col, Divider, Row, Space, Statistic, Tag } from 'antd'
import React from 'react'
import { LOGGED_USER } from '../../../../variables/constants'

const CourtierProfil = ({ courtier, setTCModalOpen, myAgreement }) => {
    return (
        <Card
            style={{
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                border: 'none'
            }}
        >
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <Avatar
                    size={100}
                    style={{
                        background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                        fontSize: '40px',
                        fontWeight: 700,
                        marginBottom: '16px'
                    }}
                >
                    {courtier?.nom?.charAt(0)}
                </Avatar>
                <h3 style={{
                    margin: '12px 0 4px 0',
                    color: '#242166',
                    fontSize: '20px',
                    fontWeight: 700
                }}>
                    {courtier?.nom}
                </h3>
                <Tag
                    color={courtier?.restrictionProduction ? 'red' : 'green'}
                    style={{
                        borderRadius: '6px',
                        padding: '4px 12px',
                        fontSize: '14px',
                        fontWeight: 500
                    }}
                >
                    {courtier?.restrictionProduction ? 'Inactif' : 'Actif'}
                </Tag>
            </div>

            <Row gutter={[16, 16]} style={{ marginBottom: '32px' }}>
                <Col span={12}>
                    <Card
                        style={{
                            background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                            borderRadius: '12px',
                            border: 'none',
                            textAlign: 'center'
                        }}
                    >
                        <UserOutlined style={{ fontSize: '32px', color: 'white' }} />
                        <Statistic
                            value={courtier?.affairesCount}
                            valueStyle={{
                                color: 'white',
                                fontSize: '24px',
                                fontWeight: 700,
                                marginTop: '8px'
                            }}
                            suffix={<span style={{ fontSize: '14px' }}>Affaires</span>}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card
                        style={{
                            background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                            borderRadius: '12px',
                            border: 'none',
                            textAlign: 'center'
                        }}
                    >
                        <DollarOutlined style={{ fontSize: '32px', color: 'white' }} />
                        <Statistic
                            value={courtier?.commissionsTotal}
                            valueStyle={{
                                color: 'white',
                                fontSize: '18px',
                                fontWeight: 700,
                                marginTop: '8px'
                            }}
                            suffix={<span style={{ fontSize: '12px' }}>FCFA</span>}
                        />
                    </Card>
                </Col>
            </Row>

            <Divider style={{ margin: '24px 0' }} />

            <div style={{ padding: '0 8px' }}>
                <h4 style={{
                    color: '#242166',
                    fontSize: '16px',
                    fontWeight: 700,
                    marginBottom: '20px'
                }}>
                    Informations détaillées
                </h4>

                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            RESPONSABLE
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <UserOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.responsable || `${courtier?.gerant?.nom} ${courtier?.gerant?.prenom}`}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            EMAIL
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <MailOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.email}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            CONTACTS
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <PhoneOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.contact && courtier?.contact[0]}
                            {courtier?.contact && courtier?.contact[1] && (
                                <div style={{ marginLeft: '24px', marginTop: '4px' }}>
                                    {courtier?.contact[1]}
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            SIÈGE SOCIAL
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <BankOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.ville}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            SITE WEB
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <GlobalOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.website}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            NIF
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            {courtier?.nif}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            TAUX DE COMMISSION
                        </div>
                        <div>
                            {LOGGED_USER?.profil.organisme.typeOrganisme === "POOL" ?
                                courtier?.validAgrements?.map((va) => (
                                    <div key={va.agreementId}>
                                        <u>{va.compagnie.raisonSociale}</u><br />
                                        {va?.tauxCommission ? va?.tauxCommission?.map(tc => (
                                            <Tag
                                                key={tc?.codeId}
                                                color="#242166"
                                                style={{
                                                    margin: '4px 4px 4px 0',
                                                    borderRadius: '6px',
                                                    padding: '4px 8px'
                                                }}
                                            >
                                                {tc?.categorie?.nom} : {tc?.taux}%
                                            </Tag>
                                        )) : "Non défini"}
                                    </div>
                                )) :
                                <>
                                    {myAgreement?.tauxCommission ? myAgreement?.tauxCommission?.map(tc => (
                                        <Tag
                                            key={tc.codeId}
                                            color="#242166"
                                            style={{
                                                margin: '4px 4px 4px 0',
                                                borderRadius: '6px',
                                                padding: '4px 8px'
                                            }}
                                        >
                                            {tc.categorie.nom}: {tc.taux}%
                                        </Tag>
                                    )) : "Non défini"}
                                </>}
                        </div>
                    </div>
                </Space>

                <Button
                    type="primary"
                    block
                    size="large"
                    icon={<EditOutlined />}
                    onClick={() => setTCModalOpen(true)}
                    style={{
                        marginTop: '24px',
                        background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        height: '44px',
                        fontWeight: 600
                    }}
                >
                    Gérer les taux de commission
                </Button>
            </div>
        </Card>
    )
}

export default CourtierProfil